import type { MentionNames, ReviewAction } from "../types"
import NoteText from "./NoteText"

// Actions on other products whose note names this one with #id.
export default function MentionedBy({ mentions, names }: { mentions: ReviewAction[]; names: MentionNames }) {
  return mentions.map((m) => (
    <div key={m.id} className="mt-2 text-sm">
      Named in an action for <NoteText note={`#${m.product_external_id}`} names={names} />:{" "}
      <span className="font-semibold">{m.action_type}</span> · <NoteText note={m.note} names={names} />
    </div>
  ))
}
